import { useState } from 'react'
import TableTab2 from "./TableTab2";
import {
  useItemWarehouseCheckInListMutation,
  useItemCompanyMutation,
  usePriceDetailsListMutation
} from "../../../../store/api/itemapi";
const Tab2 = ({ pageState,setPageState,setselected_default_item_data,company_list_data,warehouse_list_data,price_list}) => {
   const [ItemCompanyApi] = useItemCompanyMutation();
   const [WarehouseApi] = useItemWarehouseCheckInListMutation();
   const [PriceListApi] = usePriceDetailsListMutation();
  return (
   <div>
      <div className="px-4" style={{ background: 'white' }}>
   <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Defaults</p>
                </div>
              </div>

                <TableTab2
  setselected_default_item_data={{
    value: pageState.selected_default_item_data || [],
    setValue: (val) =>
      setPageState({
        ...pageState,
        selected_default_item_data: val,
      }),
  }}
  company_list_data={ItemCompanyApi}
  warehouse_list_data={WarehouseApi}
  price_list={PriceListApi}
/>



              </div>
            </div>

          </div>
          </div>
          </div>
   
  )
}

export default Tab2